<template>
  <div  class="video-box" :data-isp="isPortrait" :data-ispc="isPC">
    <div class="overlay-text">{{ title }}</div>
    <div style="position: relative;">
      <video  v-if="isPC" :poster="videoposter" class="custom-video" :controls="isControls"  autoplay preload="auto" loop webkit-playsinline="true" playsinline="true" x5-video-player-type="h5"  x5-video-player-fullscreen="true" muted>
        <source :src="videosrc" :poster="videoposter">
      </video>
      <img style="padding: 0 20px;" :src="videopostermob" v-if="!isPC" />
      <img src="https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/video/play-icon.png" alt="Overlay Image" class="overlay-image" @click="playVideo" :code-stm="`event, PAGEURL, ${maidiansuffix} 点击封面视频/图片按钮`">
    </div>
    <my-video :isShow="isShowVideo" :videoSrc="videofullsrc" @closeDialog="closeVideo" :maidiansuffix="maidiansuffix"></my-video>
  </div>
</template>
<script>
import { isPortraitFun, getUrlKey, isPc } from "@/utils/utils.js";
import MyVideo from '@/components/basic-video.vue'
export default {
  name: 'BasicSingleVideo',
  data() {
    return {
      isShowVideo: false,
      isPortrait: isPortraitFun(),
      isPC: isPc(),
      isControls:false
    }
  },
  components: {
    MyVideo
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    videosrc: {
      type: String,
      default: ''
    },
    videofullsrc: {
      type: String,
      default: ''
    },
    videoposter: {
      type: String,
      default: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/safe/img1.png'
    },
    videopostermob: {
      type: String,
      default: ''
    },
    maidiansuffix: {
      type: String,
      default: ''
    }
  },
  methods: {
    closeVideo() {
      this.isShowVideo = false;
      // this.videofullsrc = "";
      if(this.maidiansuffix == 'ev5 E-GMP视频'){//ev5
        window.parent.postMessage({ type: 'ev5SwiperVideoClose' }, '*')
      }
    },
    playVideo() {
      this.isShowVideo = true
      if(this.maidiansuffix == 'ev5 E-GMP视频'){//ev5
        window.parent.postMessage({ type: 'ev5SwiperVideoOpen' }, '*')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.video-box{
  height: 100vh;
  position: relative;
  /* text-align: center; */
  /* top: 50%; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.custom-video{
  width:calc(1520 / 1920 * 100vw);
  height:calc(672 / 1080 * 100vh);
  object-fit: cover;
  position: relative;
}
.custom-video::-webkit-media-controls {
  display: none !important;
}

.custom-video::-webkit-media-controls-enclosure {
  display: none !important;
}
.overlay-image {
  position: absolute;
  top: 50%;
  left: 50%;
  width: calc(50/1920*100vw);
  height: calc(50/1920*100vw);
  object-fit: cover;
  z-index: 1;
  transform: translate(-50%,-50%);
  cursor: pointer;
}
.overlay-text {
  width: 100%;
  text-align: center;
  z-index: 1;
  font-size: 2.083333vw;
  font-weight: 800;
  margin-bottom: 40px;
}
@media (max-width:767px){
  .overlay-image{
    width:calc(75/750*100vw);
    height:calc(75/750*100vw);
  }
  .overlay-text{
    font-size:calc(48/750*100vw);
  }
}
</style>
